export function linear(t) {
  return +t;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-ease/src/linear.js
// module id = 259
// module chunks = 0 1 2 3 4